'use strict';

var aiEventTracker = require('./chat/247aiEventTracker');
require('./chat/psp247/247tag');

aiEventTracker.trackEvent();
